import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyBF12TmaKCaaaLWig5TOwILT3CjR12pmss",
  authDomain: "gigatech-crm.firebaseapp.com",
  projectId: "gigatech-crm",
  storageBucket: "gigatech-crm.firebasestorage.app",
  messagingSenderId: "53827039428",
  appId: "1:53827039428:web:66209ecd929ed986dc1991",
  measurementId: "G-Y5L8L8YQYC"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

export default app;